import styled from 'styled-components';

import {PcBox as BasePcBox, MobileBox as BaseMobileBox} from './useful-links-item.default.box'
import {styledByDevice} from '../../../../themes/architecture/styled-by-device';

const PcBox = BasePcBox;

const MobileBox = styled(BaseMobileBox)`
    padding-left: 0;

    text-transform: uppercase;
    ${({theme}) => theme.font.presets.medium};
    &:after {
        content: none;
    }

     &:first-child {
        margin-top: 0;
        border-top: 0;
    }
`;

export const UsefulLinksItemCipBox = styledByDevice(PcBox, MobileBox);